/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateAssistantForm,
  CreateAssistantForm$Outbound,
  CreateAssistantForm$outboundSchema,
} from "../components/createassistantform.js";

export type CreateAssistantSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateAssistantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createAssistantForm: CreateAssistantForm;
};

/** @internal */
export type CreateAssistantSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateAssistantSecurity$outboundSchema: z.ZodMiniType<
  CreateAssistantSecurity$Outbound,
  CreateAssistantSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createAssistantSecurityToJSON(
  createAssistantSecurity: CreateAssistantSecurity,
): string {
  return JSON.stringify(
    CreateAssistantSecurity$outboundSchema.parse(createAssistantSecurity),
  );
}

/** @internal */
export type CreateAssistantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateAssistantForm: CreateAssistantForm$Outbound;
};

/** @internal */
export const CreateAssistantRequest$outboundSchema: z.ZodMiniType<
  CreateAssistantRequest$Outbound,
  CreateAssistantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createAssistantForm: CreateAssistantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createAssistantForm: "CreateAssistantForm",
    });
  }),
);

export function createAssistantRequestToJSON(
  createAssistantRequest: CreateAssistantRequest,
): string {
  return JSON.stringify(
    CreateAssistantRequest$outboundSchema.parse(createAssistantRequest),
  );
}
